// src/constants/statuses.js

export const LoanStatuses = {
  NEW_APPLICATION: 'New Application',
  SUBMITTED: 'Submitted',
  PREQUALIFIED_FOR: 'Prequalified',
  DOCUMENT_CLARIFICATION: 'Document Clarification',
  CLOSING: 'Closing',
  TERM_SHEET_EXTENDED: 'Term Sheet Extended',
  AWAITING_TERM_SHEET: 'Awaiting Term Sheet',
  TERM_SHEET_GIVEN: 'Term Sheet Given',
  TERM_SHEET_SIGNED: 'Term Sheet Signed',
  UNDERWRITING: 'Underwriting',
  FUNDED: 'Funded',
  REJECTED: 'Rejected',
  // Add other statuses as needed
};

export const StatusNextSteps = {
  [LoanStatuses.NEW_APPLICATION]: 'Submit Application',
  [LoanStatuses.SUBMITTED]: 'Await Prequalification',
  [LoanStatuses.PREQUALIFIED_FOR]: 'Await Document Review',
  [LoanStatuses.DOCUMENT_CLARIFICATION]: 'Answer Questions and Submit Needed Documents',
  [LoanStatuses.AWAITING_TERM_SHEET]: 'Awaiting Lender Term Sheet',
  [LoanStatuses.TERM_SHEET_GIVEN]: 'Review and Sign Term Sheet',
  [LoanStatuses.TERM_SHEET_SIGNED]: 'Move to Underwriting',
  [LoanStatuses.TERM_SHEET_EXTENDED]: 'Sign and Move into Underwriting',
  [LoanStatuses.UNDERWRITING]: 'Await Feedback/Further Questions',
  [LoanStatuses.FUNDED]: '',
  [LoanStatuses.REJECTED]: '',
};

